// /link-error — terminal error page for the Ring App Store install flow.
//
// The backend's /oidc/ring-link-* legs 302 here with ?code=<RingLinkErrorCode>
// (and optionally &alias=<existing admin> for the tenant-bound-to-different-
// alias case). This page renders the cert-required LLD 09 Appendix A copy from
// ringLinkMessages. Public/pre-session: these failures happen before a session
// cookie is minted, so the page must render without auth (it is in the
// SessionProvider pre-session allowlist).

import { useState } from "react";
import { ringLinkMessage } from "@/ringlink/ringLinkMessages";

function readParams(): { code: string | null; alias: string | null } {
  const q = new URLSearchParams(window.location.search);
  return { code: q.get("code"), alias: q.get("alias") };
}

export function LinkErrorPage(): JSX.Element {
  const [{ code, alias }] = useState(readParams);
  return (
    <div className="reb-page">
      <div className="reb-card" style={{ textAlign: "center" }}>
        <h1 className="reb-page__title">We can't finish linking right now</h1>
        <p className="reb-error" role="alert">
          {ringLinkMessage(code, alias)}
        </p>
        <p className="reb-page__subtitle">
          Please reinstall the bridge from the Ring app and try again.
        </p>
      </div>
    </div>
  );
}
